export const booking = {
	reserve: {
		label: "Paquetes",
		search: "Buscar paquetes",
		create: "Crear paquete",
		empty: {
			title: "No hay paquetes para este evento",
			subtitle:
				"Crea tu primer paquete haciendo clic en el botón 'Crear paquete' en la parte superior de esta página",
		},
		reserveCard: {
			guests: "{{count}} invitados",
			promotions: "{{count}} promociones",
			none: "Ninguna promoción seleccionada",
			people: "{{count}} personas confirmadas",
		},
		reserveDetail: {
			title: "Paquete de",
			confirmed: "{{count}} confirmados",
			of: "de",
			guestsCount: "{{count}} invitados",
			delete: "¿Está seguro de que desea eliminar este producto?",
			promotions: "Promociones del paquete",
			none: "Ninguna promoción seleccionada",
			guests: "Invitados",
			invoices: "Facturas generadas",
			value: "Valor del paquete",
			issueInvoice: "Emitir factura",
			copyModal: {
				defaultReserveName: "Copia de {{name}}",
				title: "Crear copia del paquete",
				copy: "Copiar",
				text: "¿Desea crear copia de reserva?",
				placeholder: "Nombre de la copia del paquete",
				errors: {
					inputs: "Los campos no se completaron correctamente.",
					name: "El nombre del paquete es igual al nombre original.",
					length: "El nombre del paquete no alcanzó la cantidad mínima de caracteres.",
				},
			},
			modal: {
				title: "Emitir factura para {{name}}",
				issueInvoice: "Emitir factura",
				fiscalProfile: "Perfil Fiscal",
				cpf: "RFC",
				cnpj: "RFC",
				none: "Ninguno",
				paymentMethod: "Método de pago",
				fiscalGroup: "Grupo Fiscal",
				ncm: "NCM",
				cest: "CEST",
				value: "Valor",
				remove: "Eliminar",
				add: "Agregar grupo fiscal",
				tip: "Propina",
				removeTip: "Eliminar propina",
				invoiceValue: "Valor de la factura",
				invoiceAlert: "Las facturas con valor mayor a $10,000 serán divididas.",
				packageValue: "Valor del paquete",
				discount: "Descuentos",
				total: "Total",
				chooseOptions: "Elija una de las opciones",
				addDiscount: "Agregar descuentos en la factura",
				completeValue: "Completar el valor del paquete",
				optionalTip: {
					title: "Propina (opcional)",
					add: "Agregar propina",
				},
				inputMultiplePaymentsManual: {
					label: "Método de pago",
					placeholder: "Seleccione",
					value: "Valor",
					add: "Agregar pago",
				},
				errors: {
					value: "Incluya algún producto con valor para utilizar esta funcionalidad",
					inputs: "Los campos no se completaron correctamente",
				},
			},
			tableMultiplePayment: {
				columns: {
					paymentMethod: "Método de pago",
					value: "Valor",
				},
				total: "Total agregado",
			},
			peopleDidntArrive: {
				title: "Desconocido",
				subtitle: "Sin información",
			},
			peopleArrived: {
				title: "En el evento",
				subtitle: "Ya salió",
			},
		},
		reserveModal: {
			inactive: " (Promoción inactiva)",
			edit: "Editar paquete",
			create: "Crear",
			newTemplate:
				"¡Atención! El modelo creado podrá ser utilizado por todos los eventos de esta ubicación.",
			template:
				"El paquete puede ser personalizado, pero creará asociación al modelo para ser usado en informes y métricas.",
			models: "Modelos",
			clientInfo: "Información del cliente",
			name: "Nombre",
			estimatedPeopleCount: "Número de invitados",
			value: "Valor del paquete",
			expiresAt: "Expira en",
			promotion: "Promoción",
			promotionLabel: "Promoción {{number}}",
			updateModal: {
				promotionName: "Nombre de la promoción",
				description: "Descripción",
				productName: "Nombre del producto",
				percentage: "Porcentaje",
			},
			modalTitle: {
				edit: "Editar {{name}}",
				newTemplate: "Crear modelo",
				template: "Crear a partir de modelo",
				create: "Crear paquete",
			},
			errors: {
				selectedTemplate: "No se pudo encontrar el modelo",
				promotion: "Ninguna promoción seleccionada",
				inputs: "Complete todos los campos obligatorios para la categoría seleccionada.",
			},
		},
		reserveOptions: {
			create: {
				name: "Cree paquete personalizado",
				label:
					"Defina cómo será el paquete ofrecido y si lo desea incluya una promoción.",
			},
			createWithTemplate: {
				name: "Cree a partir de modelo",
				label:
					"Cree un paquete para sus clientes basado en los modelos creados anteriormente.",
			},
			createTemplate: {
				name: "Cree nuevo modelo",
				label:
					"Cree un modelo personalizado de paquete para utilizar en el futuro en sus eventos.",
			},
			canBeUsedIn: "Podrá ser usado en",
			allEvents: "todos los eventos",
			fromThisPlace: "de esta ubicación",
			managePackages: "Administrar paquetes",
		},
		reserveTemplate: {
			loading: "Cargando ...",
			empty: "La ubicación no tiene ningún modelo registrado.",
			remove: "Eliminar",
			value: "Valor del paquete",
			guests: "Invitados",
			promotions: "Promociones",
			modalConfirm: {
				title: "¿Está seguro de que quiere eliminar el modelo?",
				content: "Ya no podrá ser utilizado en ningún evento de esta ubicación.",
			},
		},
	},
	reserveReport: {
		label: "Informe de paquetes",
		subtitle: {
			none: "Ningún paquete activo durante el evento",
			one: "un paquete activo durante el evento",
			default: "{{count}} paquetes activos durante el evento",
		},
	},
};
